// Etiket/değer satırı; fiyat dökümü ve oturum sepetinde kullanılır.
import { cn } from "@/shared/utils/cn";

export interface PosRowProps {
  label: string | React.ReactNode;
  children: string | number;
  fontSize?: "sm" | "md" | "lg";
  fontWeight?: "normal" | "semibold" | "bold";
  color?: string;
  className?: string;
  hideMargin?: boolean;
}

const fontSizes = {
  sm: "1.4rem",
  md: "1.6rem",
  lg: "1.8rem",
};

const fontWeights = {
  normal: "500",
  semibold: "600",
  bold: "700",
};

const PosRow = ({
  label,
  fontSize = "md",
  fontWeight = "semibold",
  children,
  color = "text",
  className,
  hideMargin = false,
}: PosRowProps) => {
  return (
    <div
      className={cn(
        "flex items-center justify-between gap-3",
        !hideMargin && "mb-2",
        className
      )}
      style={{
        fontSize: fontSizes[fontSize],
        fontWeight: fontWeights[fontWeight],
        color: `var(--${color.replace(/_/g, "-")})`,
      }}
    >
      <div className="min-w-0 flex-1">{label}</div>
      <div
        className="shrink-0 tabular-nums"
        style={{ height: fontSize === "sm" ? "2rem" : "2.25rem" }}
      >
        {children}
      </div>
    </div>
  );
};

export default PosRow;
